<template>
    <div class="container" id="AddMember_container" v-title="'新增队员'">
        <Navigation-bar :title="scrollTop > titleHeight ? '新增队员' : ''" v-scrollShadow="scrollTop" @backPage="backPage()"></Navigation-bar>
         <div class="container_content">
             <div id="AddMember" v-scroll="scrollTop">
                <Title title="新增队员" subtitle="填写人员基本信息"></Title>
                 <div class="AddMember_content">
                    <Fold label="1.姓名" 
                        :text="form.name" 
                        :unfold="unfoldName == 'name'" 
                        :error="errorUnfold == 'name'" 
                        :required="true"
                        @unfold-change="unfoldChange(...arguments, 'name')" 
                    >
                        <Input v-model.trim="form.name" :focus="unfoldName == 'name'" placeholder="请输入姓名" ref="name" maxlength="20" @input="nameChange"></Input>
                    </Fold>
                    <Fold label="2.手机号" 
                        :text="form.phone" 
                        :unfold="unfoldName == 'phone'" 
                        :error="errorUnfold == 'phone'" 
                        :required="true"
                        @unfold-change="unfoldChange(...arguments, 'phone')" 
                    >
                        <Input type="tel" pattern="\d*" maxlength="11" v-model.trim="form.phone" :focus="unfoldName == 'phone'" placeholder="请输入手机号" @input="phoneChange"></Input>
                        <div class="phoneHint">
                            <p v-if="verify.state == 1">此号码已被您队伍中的{{verify.name}}使用，请核实</p>
                            <p v-else-if="verify.state == 2">此号码已被系统中其他人员占用请<span @click="verify.state = 3">验证手机号</span></p>
                            <div class="codeBox" v-else-if="verify.state == 3">
                                <div class="code_input">
                                    <Input type="tel" pattern="\d*" maxlength="6" v-model.trim="verify.code" placeholder="请输入验证码" :class="{'error':verify.error}"></Input>
                                    <span v-show="(verify.isFirst || verify.code.length != 6) && this.countDown == 60" class="text-btn" @click="sendCode()">{{!verify.isFirst ? '重新发送' : '获取验证码'}}</span>
                                    <span v-show="verify.code.length != 6 && this.countDown < 60" class="text-btn" style="color: #1B1C1E;" v-text="countDownText"></span>
                                    <button v-show="verify.code.length == 6 && !verify.isFirst" @click="verifyCode()">验证</button>
                                </div>
                            </div>
                        </div>
                    </Fold>
                    <template v-if="verify.isSuccess">
                    <Fold label="3.证件类型" 
                        :text="cardInfo.name" 
                        :unfold="unfoldName == 'identityType'" 
                        :error="errorUnfold == 'identityType'" 
                        :required="isAthlete && fieldsOptions.identity_limit == 1 || fieldsOptions.identity_limit == 9"
                        @unfold-change="unfoldChange(...arguments, 'identityType')" 
                    >
                        <div>
                            <Option v-for="(item,index) in identityTypeList" :key="index"
                                :active="form.identityType == item.type" :disabled="isRealName || isEnrollGroup"
                                @click="selectIdentityType(item.type)">{{item.name}}</Option>
                        </div>
                    </Fold>
                    <Fold label="4.证件号" 
                        :text="form.identityNo" 
                        :unfold="unfoldName == 'identityNo'" 
                        :error="errorUnfold == 'identityNo'" 
                        :required="isAthlete && fieldsOptions.identity_limit == 1 || fieldsOptions.identity_limit == 9"
                        @unfold-change="unfoldChange(...arguments,'identityNo')" 
                    >
                        <Input v-model.trim="form.identityNo" :focus="unfoldName == 'identityNo'" :disabled="isRealName || isEnrollGroup" placeholder="请输入证件号" :maxlength="cardInfo.len || 18" @input="identityNoChange"></Input>
                    </Fold>
                    <Fold label="5.性别" 
                        :text="['男','女'][form.sex - 1]" 
                        :unfold="unfoldName == 'sex'" 
                        :error="errorUnfold == 'sex'" 
                        :required="isAthlete && fieldsOptions.sex_limit == 1 || fieldsOptions.sex_limit == 9"
                        @unfold-change="unfoldChange(...arguments,'sex')" 
                    >
                        <template v-if="(form.identityType == 1 && (fieldsOptions.identity_limit == 1 && isAthlete || fieldsOptions.identity_limit == 9 || !!form.identityNo)) || isRealName || isEnrollGroup">
                            <Option :active="form.sex == 1" disabled key="a1">男</Option>
                            <Option :active="form.sex == 2" disabled key="a2">女</Option>
                        </template>
                        <template v-else>
                            <Option :active="form.sex == 1" @click="sexChange(1)" key="b1">男</Option>
                            <Option :active="form.sex == 2" @click="sexChange(2)" key="b2">女</Option>
                        </template>
                    </Fold>
                    <Fold label="6.出生日期" 
                        :text="form.birthDate" 
                        :unfold="unfoldName == 'birthDate'" 
                        :error="errorUnfold == 'birthDate'" 
                        :required="isAthlete && fieldsOptions.birthday_limit == 1 || fieldsOptions.birthday_limit == 9"
                        @unfold-change="unfoldChange(...arguments,'birthDate')" 
                    >
                        <template v-if="(form.identityType == 1 && (fieldsOptions.identity_limit == 1 && isAthlete || fieldsOptions.identity_limit == 9 || !!form.identityNo)) || isRealName || isEnrollGroup">
                            <Option disabled key="1">{{form.birthDate || "选择日期"}}</Option>
                        </template>
                        <template v-else>
                            <Option @click="setDate()" key="2">{{form.birthDate || "选择日期"}}</Option>
                        </template>
                    </Fold>
                    <Fold label="7.参赛人员身份" 
                        :text="roleText" 
                        :unfold="unfoldName == 'roleValue'" 
                        :error="errorUnfold == 'roleValue'" 
                        :required="true"
                        @unfold-change="unfoldChange(...arguments,'roleValue')" 
                    >
                        <div class="role">
                            <template v-for="(item,index) in roles">
                                <template v-if="item.children">
                                    <Option :key="'a' + index" 
                                        checkbox
                                        :active="getRoleChildrenActive(item.children)"
                                        @click="selectRole(item.children[0])"
                                    >{{item.name}}</Option>
                                    <div class="children" :key="'b' + index" v-show="getRoleChildrenActive(item.children)">
                                        <Option v-for="(CItem,CIndex) in item.children" :key="CIndex"
                                            checkbox
                                            :active="getRoleActive(CItem)"
                                            @click="selectRole(CItem)"
                                        >{{CItem.RoleName}}</Option>
                                    </div>
                                </template>
                                <template v-else>
                                    <Option :key="'c' + index" 
                                        disabledTrigger
                                        checkbox
                                        :active="getRoleActive(item)"
                                        :disabled="getRoleDisabled(item)"
                                        @click="selectRole(item)"
                                    >{{item.RoleName}}</Option>
                                </template>
                            </template>
                        </div>
                        <div class="explain_button" @click="openExplain(1)">
                            <div>
                                <YD-image src="icon/icon_说明"></YD-image>
                                <span>身份说明</span>
                            </div>
                        </div>
                    </Fold>
                    <Fold label="8.参赛人员组别" 
                        :text="groupText" 
                        :unfold="unfoldName == 'groupValue'" 
                        :error="errorUnfold == 'groupValue'" 
                        :required="isAthlete"
                        @unfold-change="unfoldChange(...arguments,'groupValue')" 
                    >
                        <div>
                            <Option :active="isNoGroup"
                                @click="selectGroup(1)"
                            >暂不选组</Option>
                            <Option v-for="(item,index) in groups" :key="index"
                                disabledTrigger
                                :checkbox="!isNoGroup"
                                :active="getGroupActive(item)"
                                :disabled="getGroupDisabled(item) > 0"
                                @click="selectGroup(2,item)"
                            >{{item.GroupSetting.LeagueGroupName}}</Option>
                        </div>
                        <div class="explain_button" @click="openExplain(2)">
                            <div>
                                <YD-image src="icon/icon_说明"></YD-image>
                                <span>组别说明</span>
                            </div>
                        </div>
                    </Fold>
                    <template v-if="isAthlete">
                        <Fold label="9.球衣号码" 
                            :text="form.jerseyNumber" 
                            :unfold="unfoldName == 'jerseyNumber'" 
                            :error="errorUnfold == 'jerseyNumber'" 
                            :required="true"
                            @unfold-change="unfoldChange(...arguments, 'jerseyNumber')" 
                            v-if="fieldsOptions.jersey_number"
                        >
                            <Input 
                                type="tel" pattern="\d*" 
                                v-model.trim="form.jerseyNumber" 
                                :focus="unfoldName == 'jerseyNumber'" 
                                placeholder="请输入球衣号码" 
                                :maxlength="2"
                            ></Input>
                        </Fold>
                    </template>
                    <template v-if="ExtraDataDefines.length">
                        <template v-for="(item,index) in ExtraDataList">
                            <Fold :key="item.Field" :label="`${(fieldsOptions.jersey_number ? 9 : 8) + (index + 1)}.${item.Name}`" 
                                :text="extraForm[item.Field]" 
                                :unfold="unfoldName == item.Field" 
                                :error="errorUnfold == item.Field" 
                                :required="item.Mandatory"
                                @unfold-change="unfoldChange(...arguments,item.Field)" 
                            >
                                <template v-if="item.DataType == 'Text'">
                                    <Input :type="item.Precision ? 'textarea' : ''"
                                        :focus="unfoldName === item.Field" 
                                        v-model.trim="extraForm[item.Field]" 
                                        :placeholder="item.InputTips || `请输入${item.Name}`" 
                                        :maxlength="item.Max"
                                        :disabled="isEnrollGroup"
                                        @input="textInput"></Input>
                                </template>
                                <template v-else-if="item.DataType == 'Integer'">
                                    <Input type="number"
                                        :focus="unfoldName === item.Field" 
                                        integer
                                        v-model.number="extraForm[item.Field]"
                                        :placeholder="item.InputTips || `请输入${item.Name}`" 
                                        :disabled="isEnrollGroup"
                                        @input="textInput"></Input>
                                </template>
                                <template  v-else-if="item.DataType == 'Number'">
                                    <Input type="number"
                                        :focus="unfoldName === item.Field" 
                                        v-model.number="extraForm[item.Field]"
                                        :placeholder="item.InputTips || `请输入${item.Name}`" 
                                        :disabled="isEnrollGroup"
                                        @input="textInput"></Input>
                                </template>
                                <template v-else-if="item.DataType == 'Enum'">
                                    <div class="extra_select">
                                        <Option 
                                            :lineNumber="2"
                                            v-for="(option, optionIndex) in item.Values" 
                                            :key="optionIndex"
                                            :active="extraForm[item.Field] == option"
                                                :disabled="isEnrollGroup"
                                            @click="selectClick(item.Field, option)"
                                        >{{option}}</Option>
                                    </div>
                                </template>
                                <template v-else-if="['DateTime', 'Date'].includes(item.DataType)">
                                    <Input type="text"
                                        :value="extraForm[item.Field]"
                                        :placeholder="item.InputTips || `请选择${item.Name}`" 
                                        :disabled="isEnrollGroup"
                                        readonly="readonly" @click="selectDateTime(item)"></Input>
                                </template>
                            </Fold>
                        </template>
                        
                    </template>
                    <div class="upload_images_title">
                        <div class="title">请上传{{cardInfo.name}}</div>
                        <div class="desc">{{cardInfo.text}}（非必填）</div>
                    </div>
                    <div class="upload_images">
                        <div class="image_item front" @click="uploadImg(1)">
                            <img src="@images/身份证_正面@2x.png" v-show="!form.frontImg" class="default">
                            <img :src="form.frontImg" v-show="form.frontImg" class="image">
                        </div>
                        <div class="image_item behind" @click="uploadImg(2)">
                            <img src="@images/身份证_反面@2x.png" v-show="!form.behindImg" class="default">
                            <img :src="form.behindImg" v-show="form.behindImg" class="image">
                        </div>
                    </div>
                    <div class="upload_images_title">
                        <div class="title">请上传免冠大头照</div>
                        <div class="desc">
                        <template v-if="(fieldsOptions.portrait_photo == 1 && isAthlete) || fieldsOptions.portrait_photo == 9">用于制作比赛秩序册（必填）</template>
                        <template v-else>（非必填）</template>
                        </div>
                    </div>
                    <div class="upload_images">
                        <div class="image_item portrait" @click="showUploadPortraitPhoto()">
                            <img src="@images/肖像@2x.png" v-show="!form.portraitImg" class="default">
                            <img :src="form.portraitImg" v-show="form.portraitImg" class="image">
                        </div>
                    </div>
                    <button id="submit" @click="submit()">完成</button>
                    </template>
                 </div>
             </div>
         </div>
         <div id="explain" v-show="explain.show">
            <div class="explain_content" :style="{'height':explain.type == 1 ? 'auto' : '65%'}">
                <div class="explain_title">{{explain.type == 1 ? '身份说明':'组别说明'}}</div>
                <div class="explain_text" :class="{'cover':explain.type == 2}">
                    <ul v-show="explain.type == 1">
                        <li v-for="(item,index) in explain.roleDesc" :key="index">
                            <span>{{item.RoleName}}：</span>{{item.RoleDesc}}
                        </li>
                    </ul>
                    <ul v-show="explain.type == 2">
                        <li v-for="(item,index) in explain.groupDesc" :key="index">
                            <p><span>{{item.GroupName}}：</span></p>
                            <template v-if="item.GroupDesc">
                                <p v-for="(descItem,descIndex) in item.GroupDesc.split('\n')" :key="descIndex">{{descItem}}</p>
                            </template>
                            <template v-else>
                                <p>无</p>
                            </template>
                        </li>
                    </ul>
                </div>
                <div class="operation">
                    <button v-pressed @click="explain.show = false">关闭</button>
                    <button v-pressed @click="explain.show = false">确认</button>
                </div>
            </div>
        </div>
        <Datetime-picker ref="datePicker" v-bind="datePickerConfig" @change="datePickerChange"></Datetime-picker>
        <UploadPortraitPhoto ref="uploadPortraitPhoto" :ossConfig="UploadOptions"></UploadPortraitPhoto>
    </div>
</template>
<script>
import Fold from './components/Fold.vue';
import Input from './components/Input.vue';
import Option from './components/Option.vue';
import DatetimePicker from '@/components/datetime-picker/main.vue';
import UploadPortraitPhoto from '@/components/UploadPortraitPhoto.vue';

import { 
    convertSize,
    numberToChinese,
    dateFormat,
    identityCard,
    BV
} from '@js';
import {
    updatePortrait,
    backPage
} from '@js/appInteraction';
import {
    GetUserEnrollAllRoleList,//获取身份
    GetUserEnrollCanJoinGroupList,//获取组别
    GetLeagueEnrollRoleDesc,//获取身份说明
    GetLeagueEnrollGroupDesc,//获取组别说明
    CheckPhoneInDeputation,//验证身份
    GetUserRegisInfo,
    SendVerificationCode,
    CheckVerificationCode,
    AddDeputationEnrollUser,
    GetAppOwnerDeputationEnrollUploadOptions,
    GetLeagueEnrollFieldsOptions,
    GetUserInfoForDeputationAddUser
} from '@/api';
const MOBILE = /^1(3|4|5|6|7|8|9)\d{9}$/;
import extra from '@/mixins/extra';
import formValidator from '@/common/formValidator';
export default {
    name:"AddMember",
    components:{
        Fold,
        Input,
        Option,
        DatetimePicker,
        UploadPortraitPhoto
    },
    mixins: [extra],
    data(){
        return {
            subLeagueId: 0,
            deputationEnrollId: 0,
            eventsId: 0,
            userId: 0,
            scrollTop:0,
            unfoldName: '',
            errorUnfold: '',
            isDataUpdate: false,
            isRealName: false,
            form:{
                name: "",
                phone: "",
                identityType: 1,
                identityNo: "",
                sex: 0,
                birthDate:"",
                roleValue: [],
                groupValue: [],
                jerseyNumber: '',
                frontImg: "",
                behindImg: "",
                portraitImg: ""
            },
            fieldsOptions: {},
            enrollOptions: {},
            verify:{
                isSuccess: false,
                state: 0,
                name: "",
                code: "",
                error: false,
                isFirst: true
            },
            VerificationSerialNumber:"",
            countDown: 60,
            timer: null,
            roleChildren:false,
            roles:[],
            groups:[],
            explain:{
                type:1,
                show:false,
                roleDesc:[],
                groupDesc:[]
            },
            UploadOptions:{},
            datePickerConfig: {},
            isEnrollGroup: false
        }
    },
    created(){
        let subLeagueId = +this.$route.query.subLeagueId || 0,
            deputationEnrollId = +this.$route.query.deputationEnrollId || 0,
            eventsId = +this.$route.query.eventsId || 0;
        this.subLeagueId = subLeagueId;
        this.deputationEnrollId = deputationEnrollId;
        this.eventsId = eventsId;
		this.getGroupList();
        GetLeagueEnrollFieldsOptions({
            SubLeagueId: this.subLeagueId
        }).then(data=>{
            if(data.Code == 0){
                this.fieldsOptions = data.FieldsOptions;
                this.initExtraForm(data.ExtraDataDefines);
                this.enrollOptions = data.EnrollOptions;
            }
        })
        GetUserEnrollAllRoleList({
            DeputationEnrollId: this.deputationEnrollId
        }).then(data=>{
            if(data.Code == 0){
                var RoleList = data.RoleList;
                var roles = [],
                    athletes = [];
                for(var i=0;i<RoleList.length;i++){
                    let obj = RoleList[i];
                    if(obj.IsAthlete == 1){
                        athletes.push(obj);
                    }else{
                        roles.push(obj);
                    }
                }
                if(athletes.length > 1){
                    roles.push({
                        name: '运动员',
                        children: athletes
                    })
                }else{
                    roles.push(...athletes);
                }
                this.roles = roles;
            }
        })
        GetLeagueEnrollRoleDesc({
            SubLeagueId: this.subLeagueId
        }).then(data=>{
            if(data.Code == 0){
                this.explain.roleDesc = data.RoleDescList;
            }
        })
        GetLeagueEnrollGroupDesc({
            SubLeagueId: this.subLeagueId,
            EventsId: this.eventsId
        }).then(data=>{
            if(data.Code == 0){
                this.explain.groupDesc = data.GroupDescList;
            }
        })
        GetAppOwnerDeputationEnrollUploadOptions({
            DeputationEnrollId: this.deputationEnrollId
        }).then(data=>{
            if(data.Code == 0){
                this.UploadOptions = data.UploadOptions;
            }
        })

        backPage(()=>{
            this.backPage();
        })
    },
    beforeDestroy(){
        clearInterval(this.timer);
    },
    computed:{
        titleHeight(){
            return convertSize(1.08);
        },
        identityTypeList(){
            return [
                {
                    name: '身份证（港澳台居住证）',
                    text:"二代身份证（港澳台居住证）正反面照片",
                    type: 1,
                    len: 18
                },
                // {
                //     name:'护照',
                //     text:"个人信息页",
                //     type:2,
                //     len: 9,
                //     RegEx:/^[a-zA-Z0-9]{9}$/
                // },
                // {
                //     name:'台湾居民来往大陆通行证',
                //     text:"个人信息页",
                //     type:4,
                //     len: 8,
                //     RegEx:/^\d{8}$/
                // },
                // {
                //     name:'港澳居民来往内地通行证',
                //     text:"个人信息页",
                //     type:5,
                //     len: 9,
                //     RegEx:/^(H|M)\d{8}$/
                // }
            ]
        },
        roleText(){
            let length = this.form.roleValue.length;
            if(length > 0){
                return '已选择' + numberToChinese(length).replace('二','两') + '项'
            }
            return '';
        },
        groupText(){
            let length = this.form.groupValue.length;
            if(length > 0){
                return '已选择' + numberToChinese(length).replace('二','两') + '项'
            }
            return '';
        },
        cardInfo(){
            return this.identityTypeList.find(item=>item.type == this.form.identityType) || {};
        },
        countDownText(){
            return this.countDown ? this.countDown + "s" : "";
        },
        isAthlete(){
            return this.form.roleValue.some(item=>item.IsAthlete == 1);
        },
		isNoGroup(){
			return this.form.groupValue.length == 0;
		},
		rules(){
			return {
				name: (value, callback)=>{
					if(!value){
						callback('请输入姓名');
					}else if(value.length < 2){
						callback('姓名最少两个字符');
					}
					callback();
				},
				phone: (value, callback)=>{
					if(!value){
						callback('请输入手机号');
					}else if(!value.match(MOBILE)){
						callback('手机号格式有误');
					}
					callback();
				},
				identityType: (value, callback)=>{
					if(!value && (this.isAthlete && this.fieldsOptions.identity_limit == 1 || this.fieldsOptions.identity_limit == 9)){
						callback('请选择证件类型');
					}
					callback();
				},
				identityNo: (value, callback)=>{
					if(!value){
						if(this.isAthlete && this.fieldsOptions.identity_limit == 1 || this.fieldsOptions.identity_limit == 9){
							callback('请输入证件号');
						}
					}else if(this.form.identityType == 1){
						let info = identityCard(value);
						if(!info){
							callback('证件号格式有误');
						}else{
							let y = new Date(info.dateBirth).getFullYear();
							if(y < 1900 || y > new Date().getFullYear()){
								callback(y < 1900 ? '证件号年份不能小于1900' : '证件号出生年份不能大于当前年份');
							}
						}
					}else if(this.form.identityType != 1 && (value.length != this.cardInfo.len || !value.match(this.cardInfo.RegEx))){
						callback('证件号格式有误');
					}
					callback();
				},
				sex: (value, callback)=>{
					if(!value && (this.isAthlete && this.fieldsOptions.sex_limit == 1 || this.fieldsOptions.sex_limit == 9)){
						callback('请选择性别');
					}
					callback();
				},
				birthDate: (value, callback)=>{
					if(!value && (this.isAthlete && this.fieldsOptions.birthday_limit == 1 || this.fieldsOptions.birthday_limit == 9)){
						callback('请选择出生日期');
					}
					callback();
				},
				roleValue: (value, callback)=>{
					if(value.length == 0){
						callback('请选择身份');
					}
					callback();
				},
				groupValue: (value, callback)=>{
					let {
						athlete_enroll_limit
					} = this.enrollOptions;
					if(value.length > 0 && athlete_enroll_limit == 1){
						let is = value.some(item=>{
							let obj = this.groups.find(groupItem=>item.Id == groupItem.GroupSetting.LeagueGroupId);
							if(obj && obj.GroupSetting.GroupType == 2){
								return true;
							}
						})
						if(!is){
							callback('必须先报名团体组别，才能报名个人/双人组别');
						}
					}
					callback();
				},
				jerseyNumber: (value, callback)=>{
					if(this.isAthlete && this.fieldsOptions.jersey_number){
						if(!value){
							callback('请输入球衣号码');
						}else if(value < 0 || value > 99){
							callback('请输入0~99的球衣号码');
						}
					}
					callback();
				},
				portraitImg: (value, callback)=>{
					if(!value && (this.fieldsOptions.portrait_photo == 1 && this.isAthlete || this.fieldsOptions.portrait_photo == 9)){
						callback('请上传照片');
					}
					callback();
				}
			}
		}
    },
	watch:{
		// 'verify.state'(){
		// 	if(this.collapses == 'phone'){
		// 		this.$nextTick(function(){
		// 			this.$refs.collapseItemPhone.init(true);
		// 		})
		// 	}
		// },
		'form.sex'(){
			this.getGroupList();
		},
		'form.birthDate'(){
			if(this.form.identityType != 1 || !this.form.identityNo){
				this.getGroupList();
			}
		}
	},
    methods:{
        backPage(){
            if(!this.isDataUpdate){
                this.$navigation.back();
                return;
            }
            this.dataVerify().then(()=>{
                this.$Prompt({
                    title: '温馨提示',
                    message: '您的信息已填写完成，返回将不保留当前填写',
                    showCancel: true,
                    cancelText: '继续返回',
                    confirmText: '提交',
                    showClose: true
                }).then(confirm=>{
                    if(confirm){
                        this.submit();
                    }else{
                        this.$navigation.back();
                    }
                })
            }).catch(()=>{
                this.$Prompt({
                    title: '温馨提示',
                    message: '返回将不保留当前填写，请确认操作',
                    showCancel: true,
                    cancelText: '确认',
                    confirmText: '取消',
                    showClose: true
                }).then(confirm=>{
                    if(!confirm){
                        this.$navigation.back();
                    }
                })
            })
        },
        unfoldChange(e, unfold, unfoldName){
            if(!unfold){
                this.unfoldName = '';
            }else{
                this.unfoldName = unfoldName;
                this.$nextTick(function(){
                    if(!BV().ios || !['phone', 'identityNo'].includes(unfoldName)){
                        var subItemTop = e.offsetTop;
                        this.scrollTop = subItemTop - 10;
                    }
                })
            }
        },
        //数据更新
		setDataUpdate(){
			this.isDataUpdate = true;
		},
		//通用 Text
		textInput(){
			this.setDataUpdate();
		},
		//通用 Enum
		selectClick(formKey, value){
			let oldVal = this.extraForm[formKey];
			if(value != oldVal){
				this.extraForm[formKey] = value;
				this.setDataUpdate();
			}
		},
		//通用 Date
		selectDateTime(item){
			let {
				Field,
				Min,
				Max,
                DataType
			} = item;
            let {
                format,
                datePickerType
            } = this.getDateFormat(DataType);
			let date = dateFormat(this.extraForm[Field] || new Date(), format);
			let config = {
                type: datePickerType,
				value: date,
				min: dateFormat(Min || '1970-1-1 00:00:00', format),
				max: dateFormat(Max || '2099-12-31 23:59:59', format),
				formKey: Field,
                DataType
			}
            this.datePickerConfig = config;
            this.$refs.datePicker.show();
		},
		//通用 Date
		datePickerChange(value){
			let formKey = this.datePickerConfig.formKey;
			if(!formKey) return;
            if(formKey == 'birthDate'){
                this.$set(this.form, 'birthDate', dateFormat(new Date(value),'yyyy-MM-dd'));
			    this.setDataUpdate();
            }else{
                let { format } = this.getDateFormat(this.datePickerConfig.DataType);
                value = dateFormat(value, format);
                let oldVal = this.extraForm[formKey];
                if(value != oldVal){
                    this.extraForm[formKey] = value;
                    this.setDataUpdate();
                }
            }
		},
        resetVerify(isSuccess = false){
			this.verify = {
				isSuccess,
				state: 0,
				name: "",
				code: "",
				error: false,
				isFirst: true
			}
		},
		resetForm(){
			let form = this.form;
			form.identityType = 1;
			form.identityNo = "";
			form.sex = 0;
			form.birthDate = "";
			form.roleValue = [];
			form.groupValue = [];
            form.jerseyNumber = "";
			form.frontImg = "";
			form.behindImg = "";
			form.portraitImg = "";
            this.isRealName = false;
            this.isEnrollGroup = false;
		},
		nameChange(){
			if(this.verify.state != 0 || this.verify.isSuccess){
				this.resetVerify();
			}
			let form = this.form;
			clearTimeout(this.verifyTimer);
			if(form.name && form.name.length >= 2 && form.phone.match(MOBILE)){
				this.verifyTimer = setTimeout(()=>{
					this.identityCheck();
				}, 200)
			}
			this.setDataUpdate();
		},
		phoneChange(){
			this.nameChange();
		},
        identityCheck(){
            let loading = this.$Toast.loading('正在验证');
			let name = this.form.name,
				phone = this.form.phone;
            CheckPhoneInDeputation({
                DeputationEnrollId: this.deputationEnrollId,
                Name: name,
                Phone: phone
            }).then(data=>{
                loading.close();
                if(name != this.form.name || phone != this.form.phone) return;
				
				if(data.Code == 0){
					this.resetForm();
					this.resetVerify(true);
					this.unfoldName = 'identityType';
                    this.userId = 0;
                    this.$Toast('此队员未注册平台');
                }else if(data.Code == 2212){
					this.resetForm();
					this.resetVerify(true);
					this.unfoldName = 'identityType';
                    if(data.EnrollUserInfo){ //3905
                        this.isEnrollGroup = data.IsEnrollGroupInOtherDpt;
                        this.userId = data.EnrollUserInfo.UserId;
                        this.initExtraForm(undefined, data.EnrollUserInfo.Extras);
                        if(this.isEnrollGroup){
                            this.$nextTick(function(){
                                this.$Prompt({
                                    title: '报名限制',
                                    message: '该队员已在其他代表队中担任运动员，只能在此担任其他人员，且不能修改其报名信息。',
                                    confirmText: '我知道了'
                                });
                            });
                        }
                        this.getUserRegisInfo(data.EnrollUserInfo);
                    }else{ //2212
                        this.userId = data.OccupyUserId;
                        if(data.IsMe){
                            this.getUserRegisInfo();
                        }else{
                            if(data.IsPreHaveLogin){
                                this.getUserRegisInfo(undefined, 2212);
                            }else{
                                this.$Toast('此队员未注册平台');
                            }
                        }
                    }
                }else if(data.Code == 3871){
                    this.verify.state = 1;
                    this.verify.name = data.Name;
                    this.unfoldName = 'phone';
                }else if(data.Code == 2214){
                    this.verify.state = 2;
                    this.unfoldName = 'phone';
                    this.userId = data.OccupyUserId;
                }
            }).catch(()=>{
                loading.close();
            })
        },
        /**
         * 设置信息到页面
         */
        setUserInfo(userInfo){
            if(!userInfo) return;
            let form = this.form;
            form.phone = userInfo.Phone;
            form.identityType = userInfo.IdentityType || 1;
            form.identityNo = userInfo.IdentityNo || "";
            form.frontImg = userInfo.IdentityPhoto1 || "";
            form.behindImg = userInfo.IdentityPhoto2 || "";
            form.portraitImg = userInfo.PortraitPhoto || "";
            if(userInfo.IdentityType == 1 && userInfo.IdentityNo){
                let info = identityCard(userInfo.IdentityNo);
                if(info){
                    form.sex = info.sex;
                    form.birthDate = dateFormat(new Date(info.dateBirth),'yyyy-MM-dd');
                }
            }else{
                form.sex = userInfo.Gender || 0;
                form.birthDate = userInfo.Birthday ? dateFormat(new Date(userInfo.Birthday),'yyyy-MM-dd') : "";
            }
			this.$set(this, 'form', {...form});
        },
        /**
         * 获取用户注册信息
         */
        getUserRegisInfo(userInfo, code){
			if(!userInfo){
                var loading = this.$Toast.loading('读取中');
            }
			GetUserRegisInfo({
				QueryUserId: this.userId
			}).then(data => {
				if(!userInfo) loading.close();
				if(data.Code == 0){
					let regisInfo = data.RegisInfo;
			        this.isRealName = regisInfo.HasIdentitySuccess;
					if(userInfo){
						if(this.isRealName){
							let {
								IdentityPhoto1,
								IdentityPhoto2,
								PortraitPhoto
							} = userInfo;
							this.setUserInfo({
								...regisInfo,
								IdentityPhoto1,
								IdentityPhoto2,
								PortraitPhoto
							});
						}else{
							userInfo.Phone = regisInfo.Phone; //手机号可能已经更新
							this.setUserInfo(userInfo);
						}
						this.$nextTick(function(){
							this.isDataUpdate = false;
						})
					}else{
						if(code == 2212){
							this.$Toast(this.isRealName ? '此队友已实名认证，但尚未填写报名信息' : '此队友已注册平台，但尚未填写报名信息');
						}
						this.setUserInfo(regisInfo);
					}
				}
			}).catch(()=>{
                loading.close();
            })
        },
		/**
		*获取用户信息
		*/
		getUserInfo(userId){
            var loading = this.$Toast.loading('信息获取中');
			GetUserInfoForDeputationAddUser({
				DeputationEnrollId: this.deputationEnrollId,
				EnrollUserId: userId
			}).then(data=>{
                loading.close();
				if(data.Code == 0){
                    this.userId = 0;
                    this.$Toast('此队员未注册平台');
                }else if(data.Code == 2212){
                    this.userId = data.OccupyUserId;
                    if(data.IsMe){
                        this.getUserRegisInfo();
                    }else{
                        if(data.IsPreHaveLogin){
                            this.getUserRegisInfo(undefined, 2212);
                        }else{
                            this.$Toast('此队员未注册平台');
                        }
                    }
                }else if(data.Code == 3905){
                    this.isEnrollGroup = data.IsEnrollGroupInOtherDpt;
                    this.userId = data.EnrollUserInfo.UserId;
                    this.initExtraForm(undefined, data.EnrollUserInfo.Extras);
                    if(this.isEnrollGroup){
                        this.$nextTick(function(){
                            this.$Prompt({
                                title: '报名限制',
                                message: '该队员已在其他代表队中担任运动员，只能在此担任其他人员，且不能修改其报名信息。',
                                confirmText: '我知道了'
                            });
                        });
                    }
                    this.getUserRegisInfo(data.EnrollUserInfo);
                }
			}).catch(()=>{
                loading.close();
            })
		},
        sendCode(){
            let verify = this.verify;
            verify.error = false;
            verify.isFirst = false;
            let loading = this.$Toast.loading('正在发送');
            SendVerificationCode({
                MobileNumber: this.form.phone,
                Purpose: 8
            }).then(data=>{
                loading.close();
                if(data.Code == 0){
                    this.VerificationSerialNumber = data.VerificationSerialNumber;
                    clearInterval(this.timer);
                    this.countDown--;
                    this.timer = setInterval(() => {
                        this.countDown--;
                        if(this.countDown <= 0){
                            this.countDown = 60;
                            clearInterval(this.timer);
                        }
                    }, 1000);
                }
            }).catch(()=>{
                loading.close();
            })
        },
        verifyCode(){
            if(!this.verify.code){
                this.$Toast.error('请输入验证码');
                this.verify.error = true;
                return;
            }
            let loading = this.$Toast.loading('正在验证');
            CheckVerificationCode({
                MobileNumber: this.form.phone,
                VerificationSerialNumber: this.VerificationSerialNumber,
                InputVerificationCode: this.verify.code
            }).then(data=>{
                loading.close();
                if(data.Code == 0){
                    this.resetForm();
                    this.resetVerify(true);
                    this.unfoldName = 'identityType';
                    this.getUserInfo(data.UserId);
                }else if([2131,2132,2133].includes(data.Code)){
                    this.$Toast.error(data.Message);
                    this.verify.error = true;
                    this.verify.code = "";
                }else{
                    this.verify.error = true;
                }
            }).catch(()=>{
                loading.close();
                this.verify.error = true;
            })
        },
        selectIdentityType(type){
            var identityType = this.form.identityType;
            if(identityType != type){
                this.form.identityType = type;
				this.form.identityNo = '';
                this.unfoldName = 'identityNo';
            }
        },
        identityNoChange(){
			let {
				identityType,
				identityNo
			} = this.form;
			if(identityType == 1 && identityNo.length == 18){
				let info = identityCard(identityNo);
				if (!info) {
                    this.$Toast.error('证件号格式有误');
					this.errorUnfold = 'identityNo';
				}else{
					let y = new Date(info.dateBirth).getFullYear();
					if(y < 1900 || y > new Date().getFullYear()){
                        this.$Toast.error(y < 1900 ? '证件号年份不能小于1900' : '证件号出生年份不能大于当前年份');
						this.errorUnfold = 'identityNo';
					}else{
						this.form.sex = info.sex;
						this.form.birthDate = dateFormat(new Date(info.dateBirth),'yyyy-MM-dd');
					}
				}
			}else if(identityType == 1 && identityNo.length != 18){
				this.form.sex = 0;
				this.form.birthDate = "";
			}
			this.setDataUpdate();
		},
		sexChange(sex){
			if(this.form.sex != sex){
				this.form.sex = sex;
			    this.setDataUpdate();
			}
		},
        setDate(){//出生日期
			let config = {
                type: 'date',
				value: dateFormat(this.form.birthDate, 'yyyy-MM-dd'),
				min: "1900-01-01",
				max: dateFormat(new Date(),'yyyy-MM-dd'),
				formKey: 'birthDate'
			}
            this.datePickerConfig = config;
            this.$refs.datePicker.show();
        },
        selectRole(obj){
            let roles = [...this.form.roleValue];
            if(this.getRoleDisabled(obj)){
                this.$Toast.warning('该身份已满员');
                return;
            }
            if(this.getRoleActive(obj)){
				let index = roles.findIndex(item=>item.RoleId == obj.RoleId)
				roles.splice(index, 1);
				if(obj.IsAthlete == 1){
					this.$set(this.form, 'groupValue', []);
				}
            }else{
                if(obj.IsAthlete == 1){
                    let index = roles.findIndex(item=>item.IsAthlete == 1);
					let notCanPartTime = roles.find(item=>item.CanPartTime == 0);
					if(index >= 0){
						roles.splice(index, 1);
						roles.push(obj);
					}else if(notCanPartTime){
						let {RoleName} = notCanPartTime;
                        this.$Toast.warning(RoleName+'不能兼报运动员');
						return;
					}else{
						roles.push(obj);
					}
                }else{
					let isAthlete = roles.some(item=>item.IsAthlete == 1);
                    if(isAthlete && obj.CanPartTime == 0){
                        this.$Toast.warning(RoleName+'不能兼报运动员');
                        return;
                    }else{
                        roles.push(obj);
                    }
                }
            }
			this.setDataUpdate();
            this.$set(this.form, 'roleValue', roles);
        },
        getRoleActive(obj){
            return this.form.roleValue.some(item=>item.RoleId == obj.RoleId);
        },
        getRoleChildrenActive(arr){
            return arr.some(item=>{
                return this.getRoleActive(item);
            });;
        },
        getRoleDisabled(obj){
            let isInclude = this.form.roleValue.some(item=>item.RoleId == obj.RoleId);
            return !isInclude && !!obj.PeopleMax && obj.NowEnrollNum >= obj.PeopleMax;
        },
        getGroupList(){
            GetUserEnrollCanJoinGroupList({
                DeputationEnrollId: this.deputationEnrollId,
                Gender: this.form.sex || null,
                Birthday: this.form.birthDate || null,
                QueryUserId: this.userId || null
            }).then(data=>{
                if(data.Code == 0){
					let list = data.GroupList || [];
					this.groups = list;
					if(!this.isEnrollGroup){
						let groupValue = list.filter(groupItem=>
                            this.getGroupActive(groupItem) && this.getGroupDisabled(groupItem) == 0
                        ).map(groupItem=>{
							return {
                                Id: groupItem.GroupSetting.LeagueGroupId,
                                Name: groupItem.GroupSetting.LeagueGroupName
							}
						});
						this.$set(this.form, 'groupValue', [...groupValue]);
					}else{
						this.$set(this.form, 'groupValue', []);
					}
                }
            })
        },
        selectGroup(type,obj){
            if(type == 1){
                this.$set(this.form,'groupValue',[]);
                return;
            }
			let groupValue = [...this.form.groupValue];
			if(this.getGroupActive(obj)){
				let index = groupValue.findIndex(item=>item.Id == obj.GroupSetting.LeagueGroupId);
				groupValue.splice(index, 1);
			}else{
                let errorCode = this.getGroupDisabled(obj);
                if(errorCode > 0){
                    let {
                        athlete_enroll_teamgroup_num_max,
                        athlete_enroll_single_or_doublegroup_num_max
                    } = this.enrollOptions;
                    let message;
                    switch(errorCode){
                        case 1:
                            message = `该组别每队限报${obj.GroupSetting.AthletesMax}人`;
                            break;
                        case 2:
                            if(this.form.sex == 1){
                                message = `该组别每队限报${obj.GroupSetting.MaleAthletesMax}名男子`;
                            }else if(this.form.sex == 2){
                                message = `该组别每队限报${obj.GroupSetting.FemaleAthletesMax}名女子`;
                            }
                            break;
                        case 3:
                            message = '该运动员在该组别中被举报，不能报名';
                            break;
                        case 4:
                            message = `该组别每队限报${obj.GroupSetting.AthletesMax}对组合`;
                            break;
                        case 5:
                            message = '必须先报名团体组别，才能报名个人/双人组别';
                            break;
                        case 6:
                            message = '不能同时报名团体组别和个人/双人组别';
                            break;
                        case 7:
                            message = `最多只能同时报名${athlete_enroll_teamgroup_num_max}个团体组别`;
                            break;
                        case 8:
                            message = `最多只能同时报名${athlete_enroll_single_or_doublegroup_num_max}个单人/双人组别`;
                            break;
                        case 9:
                            message = '该队员已在其他代表队中担任运动员';
                            break;
						case 10:
							message = '该组别已报满';
							break;
                    }
                    this.$Toast.warning(message);
                    return;
                }

                let roles = [...this.form.roleValue];
                let isAthlete = roles.some(item=>item.IsAthlete == 1);
                if(isAthlete){
                    groupValue.push({
                        Id: obj.GroupSetting.LeagueGroupId,
                        Name: obj.GroupSetting.LeagueGroupName,
                    });
                }else{
                    let notCanPartTime = roles.find(item=>item.CanPartTime == 0);
                    if(notCanPartTime){
                        let {RoleName} = notCanPartTime;
                        this.$Toast.warning(RoleName+'不能兼报运动员');
                        return;
                    }else{
                        let RoleList = this.roles,
                            len = RoleList.length;
                        groupValue.push({
                            Id: obj.GroupSetting.LeagueGroupId,
                            Name: obj.GroupSetting.LeagueGroupName,
                        });
                        if(RoleList[len - 1].children){
                            let children = RoleList[len - 1].children;
                            roles.push(children[0]);
                        }else{
                            roles.push(RoleList[len - 1]);
                        }
                        this.$set(this.form,'roleValue',roles);
                    }
                }
            }
			this.setDataUpdate();
            this.$set(this.form,'groupValue',groupValue);
        },
        getGroupActive(obj){
			return this.form.groupValue.some(item=>item.Id == obj.GroupSetting.LeagueGroupId);
        },
        getGroupDisabled(obj){
			if(this.isEnrollGroup) return 9;
            if(obj.Impeached) return 3;//被举报
			let isInclude = this.getGroupActive(obj);
			if(!isInclude) { //涉及到多个组别之间交叉关系的判断，只能针对没有被勾中的组别。
                let {
                    athlete_enroll_limit,
                    athlete_enroll_teamgroup_num_max,
                    athlete_enroll_single_or_doublegroup_num_max
                } = this.enrollOptions;
                if(athlete_enroll_limit == 1 && [1, 3].includes(obj.GroupSetting.GroupType)){
                    let isSelectMulti = this.groups.some(item=>item.GroupSetting.GroupType == 2 && this.getGroupActive(item));
                    if(!isSelectMulti){
                        return 5;//必须先报名团体组别，才能报名个人/双人组别
                    }
                }else if(athlete_enroll_limit == 2){
                    let isSelectMulti = this.groups.some(item=>item.GroupSetting.GroupType == 2 && this.getGroupActive(item)),
                        isSelectNotMulti = this.groups.some(item=>[1, 3].includes(item.GroupSetting.GroupType) && this.getGroupActive(item));
                    if([1, 3].includes(obj.GroupSetting.GroupType) && isSelectMulti){
                        return 6;//不能同时报名团体组别和个人/双人组别
                    }else if(obj.GroupSetting.GroupType == 2 && isSelectNotMulti){
                        return 6;//不能同时报名团体组别和个人/双人组别
                    }
                }
                if(obj.GroupSetting.GroupType == 2){
                    if(athlete_enroll_teamgroup_num_max > 0){
                        let filter = this.groups.filter(item=>item.GroupSetting.GroupType == 2 && this.getGroupActive(item));
                        if(filter.length >= athlete_enroll_teamgroup_num_max){
                            return 7;//团体组数量超出
                        }
                    }
                }else{
                    if(athlete_enroll_single_or_doublegroup_num_max > 0){
                        let filter = this.groups.filter(item=>[1, 3].includes(item.GroupSetting.GroupType) && this.getGroupActive(item));
                        if(filter.length >= athlete_enroll_single_or_doublegroup_num_max){
                            return 8;//个人/双打组数量超出
                        }
                    }
                }
            }
            if(obj.GroupSetting.GroupType == 3){
                if(obj.GroupSetting.AthletesMax && obj.EnrollDoublesNum >= obj.GroupSetting.AthletesMax){
                    return 4;//组合满员
                }
            }else{
                if(obj.GroupSetting.AthletesMax && obj.EnrollNum >= obj.GroupSetting.AthletesMax){
                    return 1;//满员
                }else if(this.form.sex == 1 && obj.GroupSetting.MaleAthletesMax && obj.EnrollMaleNum >= obj.GroupSetting.MaleAthletesMax){
                    return 2;//男子满员
                }else if(this.form.sex == 2 && obj.GroupSetting.FemaleAthletesMax && obj.EnrollFemaleNum >= obj.GroupSetting.FemaleAthletesMax){
                    return 2;//女子满员
                }
            }
			// let EnrollQuotaStore = obj.GroupSetting.EnrollQuotaStore || {};
			// if(EnrollQuotaStore.TotalNum > 0 && EnrollQuotaStore.LeftNum == 0){
			// 	return 10;//组别已报满，所有报名的代表队、个人
			// }
			return 0;
        },
        openExplain(type){
            this.explain.show = true;
            this.explain.type = type;
        },
        uploadImg(type){
            if(this.isEnrollGroup){
                this.$Toast.warning('该队员已在其他代表队中担任运动员');
                return;
            }
            updatePortrait({...this.UploadOptions,Menu:0,Resolutions:'1024,768'}).then(data=>{
                if(type == 1){
                    this.form.frontImg = data.Url;
                }else if(type == 2){
                    this.form.behindImg = data.Url;
                }
				this.setDataUpdate();
            })
        },
		showUploadPortraitPhoto(){
            if(this.isEnrollGroup){
                this.$Toast.warning('该队员已在其他代表队中担任运动员');
                return;
            }
			this.$refs.uploadPortraitPhoto.choose().then(ossUrl=>{
				this.form.portraitImg = ossUrl;
				this.setDataUpdate();
			})
		},
        dataVerify(isSubmit){
			let props = Object.keys(this.rules);
			let form = this.form;
			return new Promise((resolve, reject)=>{
				new formValidator(form, props, this.rules).validate((valid, message, prop)=>{
					if(valid){
						let error = this.verifyExtraForm();
						if(error){
							valid = false;
							message = error.text;
							prop = error.id;
						}
					}
					if(isSubmit){
						if(!valid){
                            this.$Toast.error(message);
							this.unfoldName = prop;
							this.errorUnfold = prop;
							return;
						}
                        let RoleList = form.roleValue.map((item, index)=>({
							"RoleId": item.RoleId,
							"RoleName": item.RoleName,
							"OrderBy": index
						}));
						let GroupList = form.groupValue.map((item, index)=>({
							"Id": item.Id,
							"Name": item.Name,
							"OrderNo": index
						}));
						let Extras = this.getExtraForm();
						resolve({
							"DeputationEnrollId": this.deputationEnrollId,
							"EditInfo": {
								"UserId": this.userId,
								"Name": form.name,
								"Phone": form.phone,
								"IdentityType": form.identityType || null,
								"IdentityNo": form.identityNo || null,
								"Gender": form.sex || null,
								"Birthday": form.birthDate || null,
								"RoleList": RoleList,
								"GroupList": GroupList,
								"JerseyNumber": form.jerseyNumber,
								"IdentityPhoto1": form.frontImg,
								"IdentityPhoto2": form.behindImg,
								"PortraitPhoto": form.portraitImg,
								"Extras": Extras
							}
						});
					}else{
						valid ? resolve() : reject();
					}
				})
			})
        },
        submit(){
            this.dataVerify(true).then(params=>{
                AddDeputationEnrollUser(params).then(data=>{
                    if(data.Code == 0){
                        this.$Toast.success('添加成功');
                        sessionStorage.setItem('addMember','1');
                        setTimeout(()=>{
                            this.$navigation.back();
                        },500)
                    }else if(data.Code == 3883){
                        this.$Prompt({
                            title: '报名限制',
                            message: '该队员已在其他代表队中担任运动员，只能在此担任其他人员，且不能修改其报名信息。',
                            confirmText: '我知道了'
                        })
                    }
                })
            });
        }
    }
}
</script>
<style lang="scss" scoped>
#AddMember{
    position: relative;
    .AddMember_content{
        padding: 0 40px;
        box-sizing: border-box;
    }
    .phoneHint{
        margin-top: 16px;
        >p{
            font-size: 28px;
            color: #8B8C8D;
            font-weight: 400;
            line-height: 40px;
            span{
                color: #7AD21A;
                font-weight: 500;
                text-decoration: underline;
                margin-left: 8px;
            }
        }
        .codeBox{
            .code_input{
                position: relative;
                .text-btn{
                    @include line-height(40px);
                    font-size: 28px;
                    color: #7AD21A;
                    font-weight: 500;
                    text-align: right;
                    position: absolute;
                    right: 36px;
                    top: 50%;
                    margin-top: -20px;
                }
                button{
                    display: block;
                    width: 104px;
                    @include line-height(56px);
                    font-size: 28px;
                    color: #FFFFFF;
                    text-align: center;
                    font-weight: 500;
                    background: #7AD21A;
                    border-radius: 8px;
                    position: absolute;
                    right: 36px;
                    top: 50%;
                    margin-top: -28px;
                }
                .input{
                    &.error{
                        background-color: rgba(240,110,67,0.1);
                    }
                }
            }
            .error{
                font-size: 28px;
                color: #F06E43;
                font-weight: 400;
                line-height: 40px;
                margin-top: 16px;
            }
        }
    }
    
    .role{
        .children{
            .option{
                display: inline-block;
                width: calc((100% - 14px) / 2);
                @include line-height(72px);
                border-radius: 8px;
                margin-bottom: 16px;
                margin-right: 14px;
                background-image: none;
                padding-top: 0;
                padding-bottom: 0;
                &:nth-of-type(2n){
                    margin-right: 0;
                }
            }
        }
    }
    .extra_select > div{
        display: inline-block;
        width: calc((100% - 18px) / 2);
        margin-right: 18px;
        &:nth-of-type(2n){
            margin-right: 0;
        }
    }
    @include uploadImage;
    .upload_images{
        display: flex;
        .front,
        .behind{
            width: 261px;
            height: 196px;
            --center-size: 82px;
            --corner-size: 60px;
            .default{
                --width: 190px;
                --height: 116px;
            }
        }
        .front{
            margin-right: 56px;
        }
        .portrait{
            width: 240px;
            min-height: 240px;
            --center-size: 82px;
            --corner-size: 60px;
            .default{
                --width: 120px;
                --height: 160px;
            }
            
            .image{
                height: auto;
            }
        }
    }
    .explain_button{
        height: 48px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 28px;
        color: #2F343C;
        font-weight: 400;
        margin-top: 20px;
        div{
            display: flex;
            align-items: center;
        }
        img{
            height: 48px;
            width: 48px;
        }
    }
}
#submit{
    @include submit-button;
}
#explain{
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 2;
    background: rgba(0,0,0,0.40);
    display: flex;
    align-items: center;
    justify-content: center;
    .explain_content{
        width: 670px;
        background: #FFFFFF;
        box-shadow: 0px 36px 64px -8px rgba(136,136,136,0.25);
        border-radius: 20px;
        overflow: hidden;
        .explain_title{
            height: 164px;
            font-size: 36px;
            color: #3A3F49;
            font-weight: 500;
            line-height: 154px;
            padding: 0 54px;
            padding-top: 10px;
            box-sizing: border-box;
        }
        .explain_text{
            height: calc(100% - 275px);
            padding: 0 54px;
            box-sizing: border-box;
            margin-bottom: 20px;
            position: relative;
            &.cover::after{
                content: "";
                width: 100%;
                height: 152px;
                background-image: linear-gradient(180deg, rgba(255,255,255,0.00) 42%, #FFFFFF 65%);
                position: absolute;
                left: 0;
                bottom: -40px;
            }
            ul{
                height: 100%;
                overflow-y: auto;
                li{
                    span{
                        color: #7AD21A;
                        font-weight: 500;
                    }
                    font-size: 28px;
                    color: #3A3F49;
                    line-height: 44px;
                    font-weight: 400;
                    margin-bottom: 32px;
                }
            }
        }
        .operation{
            width: 100%;
            border-top: 1px solid #EFEFEF;
            display: flex;
            position: relative;
            button{
                flex: 1;
                @include line-height(90px);
                font-size: 28px;
                color: #3A3F49;
                text-align: center;
                font-weight: 500;
                border-right: 1px solid #EFEFEF;
                box-sizing: border-box;
                &.pressed{
                    background: rgba(0,0,0,0.05);
                }
                &:last-of-type{
                    color: #7AD21A;
                    border-right: none;
                }
            }
        }
    }
}
</style>
<style lang="scss">
#AddMember_container{
    .phoneHint{
        .input{
            &.error{
                .input-value{
                    background-color: rgba(240,110,67,0.1);
                }
            }
        }
    }
                
    #date_container{
        height: 100%;
        width: 100%;
        position: fixed;
        top: 0;
        left: 0;
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 20;
        background: rgba(0,0,0,0.40);
        .date_container_content{
            width: auto;
            height: auto;
            background: #FFFFFF;
            box-shadow: 0px 36px 64px -8px rgba(136,136,136,0.25);
            border-radius: 20px;
            overflow: hidden;
            margin-top: 10%;
        }
        .date_content{
            width: auto;
            height: auto;
            font-size: 28px;
            .layui-laydate{
                width: auto;
                height: auto;
                font-size: 28px;
                color: #1B1C1E;
                font-weight: 400;
                box-shadow: none;
                border: none;
                .layui-laydate-main {
                    width: auto;
                }
            }
            .layui-laydate-header{
                width: 100%;
                height: 100px;
                font-size: 32px;
                color: #7AD21A;
                line-height: 48px;
                font-weight: 700;
                display: flex;
                align-items: center;
                padding: 15px 30px 5px;
                .laydate-set-ym{
                    padding: 0 15px;
                }
                i{
                    position: static;
                    font-size: 32px;
                    padding: 0 15px;
                    color: #7AD21A;
                }
                i:hover,
                span:hover{
                    color: inherit;
                }
            }
            .layui-laydate-content{
                padding: 15px 30px;
                td,th{
                    width: 80px;
                    height: 70px;
                    border-radius: 8px;
                }
                td.layui-this{
                    color: #FFFFFF;
                    font-weight: 700;
                    background: #7AD21A !important;
                }
            }
            .layui-laydate-list{
                padding: 25px 30px;
                li{
                    width: 33%;
                    @include line-height(85px);
                    border-radius: 8px;
                    &.layui-this {
                        background: #7AD21A !important;
                    }
                }
            }
            .laydate-month-list>li{
                @include line-height(90px);
                margin: 0.15rem 0 !important;
            }
        }
        .operation{
            height:90px;
            width: 100%;
            display: flex;
            border-top: 1px #EFEFEF solid;
            button{
                flex: 1;
                @include line-height(90px);
                font-size: 28px;
                color: #3A3F49;
                text-align: center;
                font-weight: 500;
                border-right: 1px #EFEFEF solid;
                &:last-of-type{
                    color: #7AD21A;
                    border-right: none;
                }
            }
        }
    }
}
</style>